import React from 'react'
import "./button2.css"
import { Link } from 'react-router-dom'
const Button2 = ({To}) => {
  return (
    <div>
      <button  class="learn-more">
  <span class="circle" aria-hidden="true">
  <span class="icon arrow"></span>
  </span>
  <span class="button-text font-serif ps-1 my-3"><Link to={To}> See &nbsp; More </Link></span>
</button>
    </div>
  )
}

export default Button2
